import React from 'react';
import PropTypes from 'prop-types';
import {getStoreByName, setUpStore} from 'client/framework';
import ImmutablePropTypes from 'react-immutable-proptypes';
import connectToStores from 'lib/decorators/connectToStores';
import TopicList from './TopicList.react';
import LineItem from './LineItem.react';
import {GuideModelV1} from 'resources/augmented/Guide/GuideModel.v1';
import GuideLevelListStore from './GuideLevelListStore';

@connectToStores()
export default class ThemeList extends React.Component {
  static propTypes = {
    themes: ImmutablePropTypes.list.isRequired,
    guide: PropTypes.instanceOf(GuideModelV1)
  };

  componentDidMount() {
    this.props.addConnectedStores(this.getStore());
  }

  getStore() {
    const themeListStoreName = `theme-list-store-${this.props.guide.getId()}`;
    return setUpStore(GuideLevelListStore, themeListStoreName);
  }

  render() {
    if (this.props.themes.isEmpty()) {
      return null;
    }
    const store = this.getStore();
    return (
      <ul className='guide-table-list-group'>
        {this.props.themes.map((theme) => {
          const topics = this.props.guide.getSortedTopics(theme.getId());
          const hasChildren = !topics.isEmpty();
          const shouldShowChildren = store.isGuideExpanded(theme.getId());

          return [
            <LineItem
              key={theme.getId()}
              storeName={`theme-${theme.getId()}-name-overflow-store`}
              guideLevel={theme}
              indentLevel={1}
              isExpandable={hasChildren}
              isExpanded={shouldShowChildren}
              expandStoreName={store.getName()}
            />,
            hasChildren && shouldShowChildren ? (
              <TopicList
                key={`theme-${theme.getId()}-topics`}
                store={store}
                topics={topics}
                theme={theme}
                guide={this.props.guide}
              />
            ) : null
          ];
        })}
      </ul>
    );
  }
}
